import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KeyCloakApiService {
  private url = 'kc/auth/realms/Intellija/protocol/openid-connect';

  constructor(private http: HttpClient) { }

  auth<T = any>(payload?: any, endpoint?: string, 
    options?: { headers?: HttpHeaders } | { [header: string]: string | string[] },
  ) {
    return this.http.post<T>(this.getURL(`${this.url}/${endpoint}`), payload || {}, options || {});
  }

  get<T = any>(endpoint?: string,options?:
    { headers?: HttpHeaders } | { [header: string]: string | string[] }): Observable<T> {
    return this.http.get<T>(this.getURL(endpoint), options || {});
  }

  getURL(seg: string): string {
    if(seg) {
      return `${environment.BASE_URL}${seg}`;
    }

    return environment.BASE_URL;
  }
}
